import LoadingScreen from "../../LoadingScreen";
import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getBoards } from "../../../Services/boardsService";
import { getListsDashboard } from "../../../Services/boardService";
import Navbar from "../../Navbar";
import { getListsAll } from "../../../Services/boardService";
import {
  Container,
  Wrapper,
  Header,
  CardsWrapper,
  Card,
  TableWrapper,
  Table,
  FilterWrapper,
} from "./Styled";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const Dashboard = () => {
  const dispatch = useDispatch();
  const [selectedData, setSelectedData] = useState([]);

  const [selectedProduto, setSelectedProduto] = useState([]);
  const [dataSelecionado, setDataSelecionado] = useState("");
  const [produtoSelecionado, setProdutoSelecionado] = useState("");

  const { pending, boardsData = [] } = useSelector((state) => state.boards);
  const [searchString, setSearchString] = useState("");
  const [selectedQuadro, setSelectedQuadro] = useState("");

  const [isMonthLoading, setIsMonthLoading] = useState(false);
  const [isYearLoading, setIsYearLoading] = useState(false);
  const [isGrupoLoading, setIsGrupoLoading] = useState(false);
  const [dashboardLoading, setDashboardLoading] = useState(false);

    const [isBoardFetched, setIsBoardFetched] = useState(false);

  const [tableData, setTableData] = useState([]);
  const [dadosExportar, setDadosExportar] = useState([]);
  const [peso, setPeso] = useState("0");
  const [nota, setNota] = useState("0");
  const [notaFinal, setNotaFinal] = useState("0");
  const [desempenho, setDesempenho] = useState("");
  const [desconto, setDesconto] = useState("0");

  const fictitiousProducts = [
  {
    _id: "d4c6f456a7b8e90123defa04",
    description: "1.1 - PROJETOS (DISCIPLINAS DIVERSAS)"
  },
  {
    _id: "e5d5a567b8c9fa1234efab05",
    description: "1.2 - PROJETOS (INTERFERÊNCIAS)"
  },
  {
    _id: "f6e4b678c9dafb2345fabc06",
    description: "1.3 - PROJETOS (OBRAS DE ARTE ESPECIAIS)"
  },
  {
    _id: "07f3c789dafc0c3456abcd07",
    description: "2.1 - ANÁLISE DE PROJETOS (DISCIPLINAS DIVERSAS)"
  },
  {
    _id: "18a2d890ebfd1d4567bcde08",
    description: "2.2 - ANÁLISE DE PROJETOS (OBRAS DE ARTE ESPECIAIS)"
  },
  {
    _id: "6749c466eae16144ce28db10",
    description: "3.1.1 - CONSULTORIA TÉCNICA SUPRO"
  },
  {
    _id: "6749c499eae16144ce28db11",
    description: "3.2 - CONSULTORIA ESPECIAL NORMATIVOS TÉCNICOS"
  },
  {
    _id: "6749c4a6eae16144ce28db12",
    description: "3.3 - ORÇAMENTO E ESTUDOS DE CUSTOS"
  },
  {
    _id: "6749c4b2eae16144ce28db14",
    description: "3.4 - MODELAGEM BIM"
  },
  {
    _id: "6749c4b3eae16144ce28db15",
    description: "3.5 - ASSESSORIA JURÍDICA ESPECIALIZADA"
  },
  {
    _id: "1a3c6d47bce932d5f3c2d8a1",
    description: "4.1 - LEVANTAMENTO AEROFOTOGRAMÉTRICO"
  },
  {
    _id: "f49b8725a9df426d4c7e632c",
    description: "4.2 - LEVANTAMENTO TOPOGRÁFICO - LINEAR"
  },
  {
    _id: "46c7988be5d34dc5b05cc95f",
    description: "4.3 - LEVANTAMENTO TOPOGRÁFICO - OAES - ESTUDO HIDROLÓGICO"
  },
  {
    _id: "db5a42340fb44d72812ed20b",
    description: "4.4 - SONDAGEM A PERCUSSÃO"
  },
  {
    _id: "d9324ce4c67148f0bf78c01a",
    description: "4.5 - SONDAGEM ROTATIVA EM ROCHA SÃ"
  },
  {
    _id: "1fb04e72c2644fd7b274d823",
    description: "4.6 - SONDAGEM ROTATIVA EM ROCHA ALTERADA"
  },
  {
    _id: "ba874d09f8c645d0be10c22e",
    description: "4.7 - SONDAGEM A TRADO"
  },
  {
    _id: "1d9b44b35f2c4a24936f4e2b",
    description: "4.8 - COLETA DE MATERIAL DIVERSO NA VIA FERROVIÁRIA"
  },
  {
    _id: "61e8fb74e9f24b05b5d7909d",
    description: "4.9 - TRANSPORTE DE MATERIAL DIVERSO COLETADO EM VIA FERROVIÁRIA - RODOVIA EM LEITO NATURAL"
  },
  {
    _id: "7e7ac69cdd9948789aa1c807",
    description: "4.10 - TRANSPORTE DE MATERIAL DIVERSO COLETADO EM VIA FERROVIÁRIA - RODOVIA PAVIMENTADA"
  },
  {
    _id: "db0d8e10d59a46debf88b7d3",
    description: "4.11 - LIMITE DE PLASTICIDADE"
  },
  {
    _id: "c58de13c90e64897a43a3dc7",
    description: "4.12 - LIMITE DE LIQUIDEZ"
  },
  {
    _id: "3151afc8d44f43769f1aeb91",
    description: "4.13 - ANALISE GRANULOMETRICA SEM SEDIMENTACAO (PENEIRAMENTO)"
  },
  {
    _id: "155972ff0df24e1a900bdaac",
    description: "4.14 - MASSA ESPECIFICA REAL"
  },
  {
    _id: "32b6f3e5c2924c6ba7258633",
    description: "4.15 - EQUIVALENTE DE AREIA"
  },
  {
    _id: "2f6d3f963def4ba08a242a7c",
    description: "4.16 - COMPACTACAO: ENERGIA PROCTOR NORMAL"
  },
  {
    _id: "c644153f70824f6b8ff5e2e2",
    description: "4.17 - COMPACTACAO: ENERGIA AASHO INTERMEDIARIA"
  },
  {
    _id: "4a588adad46449dcba3d5a7f",
    description: "4.18 - COMPACTACAO: ENERGIA AASHO MODIFICADA"
  },
  {
    _id: "b32008a120ae4c9d9a89e54a",
    description: "4.19 - INDICE SUPORTE CALIFORNIA, POR 1 PONTO, COMPACTACAO COM ENERGIA PROCTOR NORMAL"
  },
  {
    _id: "6e08a3c37b81441fa6e98383",
    description: "4.20 - INDICE SUPORTE CALIFORNIA, POR 1 PONTO, COMPACTACAO COM ENERGIA AASHO INTERMEDIARIA"
  },
  {
    _id: "71ebf4cfdd32482abef1b6f2",
    description: "4.21 - INDICE SUPORTE CALIFORNIA, POR 1 PONTO, COMPACTACAO COM ENERGIA AASHO MODIFICADA"
  },
  {
    _id: "92dc24ba6e5c426e91cf8019",
    description: "4.22 - TRIAXIAL DRENADO, EM AMOSTRAS NATURAL OU MOLDADA, POR CORPO DE PROVA"
  },
  {
    _id: "882340cfb3904380b231dd94",
    description: "4.23 - ANALISE GRANULOMETRICA EM AGREGADO MIUDO"
  },
  {
    _id: "4f6df34b5df84e2c9817fcbe",
    description: "4.24 - ANALISE GRANULOMETRICA EM AGREGADO GRAUDO"
  },
  {
    _id: "a68f7870ed014acfa5b94f8b",
    description: "4.25 - DESGASTE A ABRASAO \"LOS ANGELES\""
  },
  {
    _id: "15c3e4c5cb8e4d31b160e68b",
    description: "4.26 - DETERMINACAO DE PERCENTAGEM DE CARBONATO DE CALCIO"
  },
  {
    _id: "75e64e2b07cd46ecb47a869e",
    description: "4.27 - ABERTURA DE PICADAS EM TERRENO COM VEGETACAO QUE POSSIBILITE O USO APENAS DE FACAO E FOICE"
  },
  {
    _id: "8f1b4c983fa040caa7754906",
    description: "4.28 - ABERTURA DE PICADAS EM TERRENO QUE EXIJA ALEM DO USO DE FACAO E FOICE,TAMBEM MACHADO E MOTOSSERRA"
  },
  {
    _id: "e8fb00ed0cbf427093d2442e",
    description: "4.29 - EXECUCAO DE LINHA DE PROSPECCAO GEOFISICA PELO METODO DE CAMINHAMENTO ELETRICO"
  },
  {
    _id: "8ce5e92fa5314bc6b126f23b",
    description: "4.30 - ABERTURA DE POÇO DE INSPEÇÃO PARA COLETA DE AMOSTRA NÃO DEFORMADA"
  },
  {
    _id: "162ba70bd9704adbad75c15e",
    description: "4.31 - ENSAIO DE PALHETA(\"VANE TEST\")REALIZADO NO CAMPO,EXCLUSIVE PERFURACAO"
  },
  {
    _id: "4358dd6c9ad4471b9243e2ef",
    description: "4.32 - DETERMINACAO DA PERDA DE MASSA POR IMERSAO DE SOLOS COMPACTADOS EM EQUIPAMENTO MINIATURA"
  },
  {
    _id: "bdde54e073aa470b9fddebd2",
    description: "4.33 - EXTRACAO DE AMOSTRA INDEFORMADA EM BLOCOS DE 30X30X30CM"
  },
  {
    _id: "4a40457f66db4c51a2db937d",
    description: "4.34 - UMIDADE NATURAL EM ESTUFA"
  },
  {
    _id: "e23e6b21d2954df9bf5796d4",
    description: "4.35 - CISALHAMENTO LENTO OU RAPIDO,POR CORPO DE PROVA"
  },
  {
    _id: "4a40458066db4c51a2db937e",
    description: "4.36 - TRIAXIAL NAO DRENADO, PRE-ADENSADO, EM AMOSTRAS NATURAL OU MOLDADA, POR CORPO DE PROVA"
  },
  {
    _id: "4a40458166db4c51a2db937f",
    description: "4.37 - MINI-MCV - SOLO COMPACTADO EM EQUIPAMENTO MINIATURA"
  },
  {
    _id: "4a40458266db4c51a2db9380",
    description: "4.38 - DETERMINACAO DE MASSA ESPECIFICA APARENTE \"IN SITU\" COM EMPREGO DO FRASCO DE AREIA."
  },
  {
    _id: "4a40458366db4c51a2db9381",
    description: "4.39 - POROSIDADE APARENTE (ABNT NBR 7418)."
  },
  {
    _id: "4a40458466db4c51a2db9382",
    description: "4.40 - ABSORÇÃO DE ÁGUA (ABNT NBR 7418)."
  },
  {
    _id: "4a40458566db4c51a2db9383",
    description: "4.41 - RESISTÊNCIA MÍNIMA À COMPRESSÃO SIMPLES AXIAL."
  },
  {
    _id: "4a40458666db4c51a2db9384",
    description: "4.42 - RESISTENCIA AO IMPACTO \"TRETON\"."
  },
  {
    _id: "4a40458766db4c51a2db9385",
    description: "4.43 - MASSA UNITÁRIA (MASSA UNITÁRIA E VAZIOS)."
  },
  {
    _id: "4a40458866db4c51a2db9386",
    description: "4.44 - AVALIACAO DAS IMPUREZAS ORGANICAS DAS AREIAS."
  },
  {
    _id: "4a40458966db4c51a2db9387",
    description: "4.45 - QUALIDADE DA AREIA COM ANALISE GRANULOMETRICA E INDICE DE MATERIA ORGANICA."
  },
  {
    _id: "4a40458a66db4c51a2db9388",
    description: "4.46 - TEOR DE ARGILA EM TORROES (AGREGADO MIUDO)."
  },
  {
    _id: "4a40458b66db4c51a2db9389",
    description: "4.47 - TEOR DE ARGILA EM TORROES (AGREGADO GRAUDO)."
  },
  {
    _id: "4a40458c66db4c51a2db938a",
    description: "4.48 - TEOR DE MATERIAIS PULVERULENTOS (AGREGADO MIUDO)."
  },
  {
    _id: "4a40458d66db4c51a2db938b",
    description: "4.49 - TEOR DE MATERIAIS PULVERULENTOS (AGREGADO GRAUDO)."
  },
  {
    _id: "4a40458e66db4c51a2db938c",
    description: "4.50 - INDICE DE FORMA (CUBICIDADE)."
  },
  {
    _id: "4a40458f66db4c51a2db938d",
    description: "4.51 - DENSIDADE APARENTE (AGREGADO MIUDO)."
  },
  {
    _id: "4a40459066db4c51a2db938e",
    description: "4.52 - DENSIDADE APARENTE (AGREGADO GRAUDO)."
  },
  {
    _id: "4a40459166db4c51a2db938f",
    description: "4.53 - MASSA ESPECÍFICA APARENTE, ABSORÇÃO E POROSIDADE."
  },
  {
    _id: "4a40459266db4c51a2db9390",
    description: "4.54 - GRANULOMETRIA COM SEDIMENTAÇÃO."
  },
  {
    _id: "7c55f45809b442fd865c4b63",
    description: "5.1 - PASSAGENS AÉREAS"
  },
  {
    _id: "650630a522504f10932cb6e0",
    description: "5.2 - DIÁRIAS"
  },
  {
    _id: "df3d9dc2bce242ef96b202a3",
    description: "5.3 - DIÁRIA DE VEÍCULO TIPO PICK-UP"
  },
  {
    _id: "0718501bce5a46b7b4ebf85c",
    description: "5.4 - DIÁRIA DE VEÍCULO TIPO LEVE"
  }
];

  const fictitiousProjetos = [
    {
      _id: "8aa22b6d0fb648d2b4ab1d72",
      description: "EF-151 - Ferrovia Norte-Sul",
    },
    { _id: "d19976df3e564ec58ef6f915", description: "EF-170 - Ferrogrão" },
    {
      _id: "682623619101b80642c7265c",
      description: "EF-232 - Ferrovia Transnordestina",
    },
    {
      _id: "a6fab99e0217497eb1009cb6",
      description: "EF-232 - Ligação da FNS com a Transnortdestina",
    },
    {
      _id: "b248c0d2d9ba462aba1da733",
      description: "EF-267 - Ferrovia do Pantanal",
    },
    { _id: "01fb307e974a46d3af3fabfa", description: "EF-277 - Ferroeste" },
    {
      _id: "dbe6aeb03eb34ef7a8f236db",
      description: "EF-280 - Corretor Ferroviário de Santa Catarina",
    },
    {
      _id: "d1ce54c9321b4ca98461749f",
      description: "EF-334 - FIOL - Ferrovia de Integração Oeste-Leste",
    },
    {
      _id: "c3ce1d07e941418da7ab52ad",
      description: "EF-354 - FICO - Ferrovia de Integração Centro Oeste",
    },
    {
      _id: "9368ce71b161495fa3407ae3",
      description:
        "EF-354 - Ferrovia Transconstinental/Ferrovia de integração Centro Oeste",
    },
    {
      _id: "00f9c0004f654980afabb11a",
      description: "EF-354 - Ferrovia Transcontinental",
    },
    { _id: "fcca502cd4a7492d87666079", description: "Estudos e Projetos" },
    { _id: "8d7b89f12c844c51979b9a5a", description: "Geral" },
    { _id: "ae4e4218a81b45e581425c3d", description: "Não se aplica" },
  ];

  const dadosComplexidade = [
    { _id: "1", description: "1 - Sem Complexidade" },
    { _id: "2", description: "2 - Pouco Complexo" },
    { _id: "3", description: "3 - Complexo" },
    { _id: "4", description: "4 - Muito Complexo" },
    { _id: "5", description: "5 - Extremamente Complexo" },
  ];

  const dadosRelevancia = [
    { _id: "1", description: "1 - Pouca Relevância" },
    { _id: "2", description: "2 - Baixa Relevância" },
    { _id: "3", description: "3 - Média Relevância" },
    { _id: "4", description: "4 - Alta Relevância" },
    { _id: "5", description: "5 - Extrema Relevância" },
  ];

  useEffect(() => {
    document.title = "Dashboard";
  }, []);

  useEffect(() => {
    const fetchBoards = async () => {
      await getBoards(false, dispatch);
      setIsBoardFetched(true);       

    };
    fetchBoards();
  }, [dispatch]);

useEffect(() => {    
  if (isBoardFetched && boardsData && boardsData.length > 0) {
    const fetchData = async () => {
      const extractedData = await extractMonthsAndYears();
      setSelectedData(extractedData);
    };

    fetchData();
  }
}, [isBoardFetched, boardsData]);

  const getIdByDescriptionComplexidade = (description) => {
    const item = dadosComplexidade.find(
      (dado) => dado.description === description
    );
    return item?._id;
  };

  const getIdByDescriptionRelevancia = (description) => {
    const item = dadosRelevancia.find(
      (dado) => dado.description === description
    );
    return item?._id;
  };

  const getDesempenhoEDesconto = (notaParcial) => {
    if (notaParcial >= 97.5 && notaParcial <= 100) {
      return { desempenho: "Excelente", desconto: "0,00%" };
    }
    if (notaParcial >= 95 && notaParcial < 97.5) {
      return { desempenho: "Ótimo", desconto: "0,50%" };
    }
    if (notaParcial >= 92.5 && notaParcial < 95) {
      return { desempenho: "Muito Bom", desconto: "1,00%" };
    }
    if (notaParcial >= 90 && notaParcial < 92.5) {
      return { desempenho: "Bom", desconto: "1,50%" };
    }
    if (notaParcial >= 87.5 && notaParcial < 90) {
      return { desempenho: "Fraco", desconto: "2,00%" };
    }
    if (notaParcial >= 85 && notaParcial < 87.5) {
      return { desempenho: "Muito Fraco", desconto: "3,00%" };
    }
    if (notaParcial >= 82.5 && notaParcial < 85) {
      return { desempenho: "Ruim", desconto: "4,00%" };
    }
    if (notaParcial >= 80 && notaParcial < 82.5) {
      return { desempenho: "Muito Ruim", desconto: "5,00%" };
    }
    return { desempenho: "Não se Aplica", desconto: "Não se Aplica" };
  };

  const getPeso = (criticidade) => {
    if (criticidade <= 6) return 1.0;
    if (criticidade <= 10) return 1.5;
    return 2.0;
  };

  // Atualiza nomeCard baseado em selectedQuadro
  const nomeCard = useMemo(() => {
    if (!selectedQuadro || !boardsData) return "";
    const selectedBoard = boardsData.find(
      (board) => board._id === selectedQuadro
    );
    return selectedBoard ? selectedBoard.title : "";
  }, [selectedQuadro, boardsData]);

  const BuscarDadosQuadro = async (e) => {
    setIsGrupoLoading(true);
    setTableData([]);
    setPeso(0);
    setNota(0);
    setNotaFinal(0);
    setDesempenho("");
    setDesconto(0);
    try {
      const updatedLists = await getListsDashboard(e, dispatch);
      if (!updatedLists) return;

      const extractedProduto = extractProduto(updatedLists);

      const formattedProducts = fictitiousProducts
        .filter((product) => extractedProduto.includes(product._id))
        .map((product) => ({
          label: product.description,
          value: product._id,
        }));

      setSelectedProduto(formattedProducts);
    } catch (error) {
      console.error("Erro ao buscar dados do quadro:", error);
    }
  };

  const handleMonthChange = (vlr) => {
    setDataSelecionado(vlr);
  };  


  useEffect(() => {
    if (produtoSelecionado || dataSelecionado || selectedQuadro) {
      atualizacaoDadosDashboard();
    }
  }, [produtoSelecionado, dataSelecionado, selectedQuadro]);

  const atualizacaoDadosDashboard = async () => {
    setDashboardLoading(true);
    const allLists = [];

    const filteredBoards = selectedQuadro
      ? boardsData.filter((item) => item._id === selectedQuadro)
      : boardsData;

    await Promise.all(
      filteredBoards.map(async (item) => {
        const lists = await getListsAll(item._id, dispatch);
        if (lists && lists.length > 0) {
          allLists.push(lists);
        }
      })
    );

    let data = formatTableDataExport(allLists);

    if (dataSelecionado) {
      data = data.filter((dado) => {
        const { dataEntrega } = dado;

        if (dataEntrega === "N/A") return false;

        const date = new Date(dataEntrega);
        const mes = date.getUTCMonth() + 1; // getUTCMonth() retorna de 0 a 11
        const ano = date.getUTCFullYear();

        const selecionadoMesAno = `${mes}/${ano}`;

        return selecionadoMesAno === dataSelecionado;
      });
    }

    if (produtoSelecionado) {
      data = data.filter((dado) => dado.produto === produtoSelecionado);
    }
    
    updateList(data);
    setTableData([]);

    const arrayData = Array.isArray(data) ? data : [data];
    setDashboardLoading(false);
    setTableData(arrayData);
  };

  const updateList = (lista) => {
    let somaPeso = 0;
    let somaNota = 0;

    const arrayLista = Array.isArray(lista) ? lista : [lista];

    arrayLista.forEach((list) => {
      const produtoDescricao =
        fictitiousProducts.find((produto) => produto._id === list.produto)
          ?.description || "Produto Desconhecido";
      list.produtoDescricao = produtoDescricao;

      // Atualiza as descrições dos projetos
      const projetosDescricao =
        fictitiousProjetos.find((projeto) => projeto._id === list.projetos)
          ?.description || "Projeto Desconhecido";
      list.projetosDescricao = projetosDescricao;

      const notaParcial =
        (list.peso *
          (parseFloat(list.n1 || 0) +
            parseFloat(list.n2 || 0) +
            parseFloat(list.n3 || 0))) /
        3;

      somaPeso += list.peso;
      somaNota += notaParcial;
    });

    setPeso(somaPeso);
    setNota(somaNota.toFixed(2));

    // Evita divisão por zero
    setNotaFinal(somaPeso > 0 ? (somaNota / somaPeso).toFixed(2) : "0.00");

    const { desempenho, desconto } = getDesempenhoEDesconto(
      (somaNota / somaPeso).toFixed(2)
    );

    setDesempenho(desempenho);
    setDesconto(desconto);
  };

  const formatTableData = (allLists) => {
    // Flatten the nested lists
    const flatData = allLists.flatMap((list) =>
      list.flatMap((cards) => {
        const cardsList = Array.isArray(cards) ? cards : cards ? [cards] : [];
        return cardsList.flatMap((cardGroup) =>
          cardGroup.cards.map((card) => ({
            idCartao: card._id,
            tituloCartao: card.title,
            projetos: card.projetos,
            projetosDescricao: "",
            produto: card.produto,
            produtoDescricao: "",
            classificacao: "",
            atividade: cardsList[0].title,
            descricaoCartao: card.description || "N/A",
            complexidade: card.complexidade || "N/A",
            relevancia: card.relevancia || "N/A",
            ordemServico: card.ordemServico,
            quantidadeExecutada: card.quantidadeExecutada,
            quantidadeOS: card.quantidadeOS,
            numSeiAbertura: card.numSeiAbertura,
            numSeiEntrega: card.numSeiEntrega,
            criticidade:
              Number(getIdByDescriptionComplexidade(card.complexidade) || "0") *
              Number(getIdByDescriptionRelevancia(card.relevancia) || "0"),
            peso: getPeso(
              Number(card.complexidade || "0") * Number(card.relevancia || "0")
            ),
            numeroSEI: card.numSei || "N/A",
            n1: card.avaliacao?.n1,
            n2: card.avaliacao?.n2,
            n3: card.avaliacao?.n3,
            notaParcial: (
              (getPeso(
                Number(card.complexidade || "0") *
                  Number(card.relevancia || "0")
              ) *
                (parseFloat(card.avaliacao?.n1 || 0) +
                  parseFloat(card.avaliacao?.n2 || 0) +
                  parseFloat(card.avaliacao?.n3 || 0))) /
              3
            ).toFixed(0),
            dataPreEntrega: card.datePreEntrega || "N/A",
            dataEntrega: card.dateEntrega || "N/A",
          }))
        );
      })
    );

    return flatData;
  };

  const handleProdutoChange = (prd) => {
    setProdutoSelecionado(prd);
  };

  const extractProduto = (data) => {
    const prod = [];

    data.forEach((board) => {
      board.cards.forEach((card) => {
        prod.push(card.produto);
      });
    });

    const uniqueProd = [...new Set(prod)];

    return uniqueProd;
  };

  const extractMonthsAndYears = async () => {
    setIsMonthLoading(true);
    const allLists = [];    

    const promises = (boardsData || []).map(async (item) => {
      const lists = await getListsAll(item._id, dispatch);
      return lists && lists.length > 0 ? lists : [];
    });

    const results = await Promise.all(promises);
    const filteredLists = results.filter((lists) => lists.length > 0);
    allLists.push(...filteredLists);

    const flatData = allLists.flatMap((list) => {
      if (!Array.isArray(list)) return [];

      return list.flatMap((obj) => {
        if (!obj?.cards) return [];

        const cards = Array.isArray(obj.cards) ? obj.cards : [obj.cards];
        return cards.map((card) => ({
          dataPreEntrega: card?.dateEntrega || "",
        }));
      });
    });

    const monthsAndYears = [];

    for (const item of flatData) {
      // Ignora strings vazias e valores inválidos
      if (!item || !item.dataPreEntrega || item.dataPreEntrega === "") continue;

      const date = new Date(item.dataPreEntrega);
      if (isNaN(date)) continue;

      const monthNumber = date.getMonth() + 1; // Janeiro = 0
      const year = date.getFullYear();

      const exists = monthsAndYears.some(
        (entry) => entry.monthNumber === monthNumber && entry.year === year
      );

      if (!exists) {
        monthsAndYears.push({ monthNumber, year });
      }
    }

    // Ordena por ano e mês
    monthsAndYears.sort((a, b) => {
      if (a.year === b.year) {
        return a.monthNumber - b.monthNumber;
      }
      return a.year - b.year;
    });

    setIsMonthLoading(false);
    // Retorna como array de strings "Mês/Ano"
    return monthsAndYears.map((item) => `${item.monthNumber}/${item.year}`);
  };

  const normalizedBoardsData = Array.isArray(boardsData)
    ? boardsData
    : Object.values(boardsData || {});

  const exportToExcel = () => {
    if (!tableData || tableData.length === 0) {
      alert("Não há dados para exportar.");
      return;
    }   

    let dados = tableData;

    const filteredData = tableData.map((row) => ({
      Projeto: row.projetosDescricao,
      Titulo: row.tituloCartao,
      Produto: row.produtoDescricao,
      Atividade: row.atividade,      
      Cartão: row.descricaoCartao,
      DescricaoCartao: row.descricaoCartao,
      OrdemServico:row.ordemServico,
      QuantidadeExecutada: row.quantidadeExecutada,
      QuantidadeOS: row.quantidadeOS,
      NumSeiAbertura:row.numSeiAbertura,
      NumSeiEntrega:row.numSeiEntrega,
      Complexidade: row.complexidade,
      Relevancia: row.relevancia,
      Criticidade: row.criticidade,
      Peso: row.peso,
      N1: row.n1,
      N2: row.n2,
      N3: row.n3,
      NP: row.notaParcial,
      DataPreEntrega:row.dataPreEntrega,
      DataEntrega:row.dataEntrega,
      Data:row.data,
      Membros:row.membros,
    }));

    let somaPeso = 0;
    let somaNota = 0;
    let notaFinal = 0;

    dados.forEach((list) => {
      const notaParcial =
        (list.peso *
          (parseFloat(list.n1 || 0) +
            parseFloat(list.n2 || 0) +
            parseFloat(list.n3 || 0))) /
        3;

      somaPeso += list.peso;
      somaNota += notaParcial;
    });

    notaFinal = somaPeso > 0 ? (somaNota / somaPeso).toFixed(2) : "0.00";

     const { desempenho, desconto } = getDesempenhoEDesconto(
      (somaNota / somaPeso).toFixed(2)
    );

    filteredData.push({});
    filteredData.push({ Projeto: "Peso", Titulo: somaPeso });
    filteredData.push({ Projeto: "Nota Parcial", Titulo: somaNota.toFixed(2) });
    filteredData.push({ Projeto: "Nota Final", Titulo: notaFinal });
    filteredData.push({ Projeto: "Desempenho", Titulo: desempenho });
    filteredData.push({ Projeto: "Desconto", Titulo: desconto });

    // Converte os dados da tabela para uma planilha
    const worksheet = XLSX.utils.json_to_sheet(filteredData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Dashboard");

    // Gera o arquivo
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });


    const data = new Blob([excelBuffer], { type: "application/octet-stream" });

    // Salva o arquivo com nome dinâmico
    const fileName = `Dashboard_${new Date().toISOString().slice(0, 10)}.xlsx`;
    saveAs(data, fileName);
  };

  const formatTableDataExport = (allLists = []) => {
  return allLists.flatMap((list) =>
    list.flatMap((group) => {
      if (!group) return [];

      const groups = Array.isArray(group) ? group : [group];

      return groups.flatMap((cardGroup) =>
        (cardGroup.cards || []).map((card) => {
          const complexidadeId = Number(
            getIdByDescriptionComplexidade(card.complexidade) || 0
          );
          const relevanciaId = Number(
            getIdByDescriptionRelevancia(card.relevancia) || 0
          );

          const criticidade = complexidadeId * relevanciaId;
          const peso = getPeso(criticidade);

          const n1 = Number(card.avaliacao?.n1 || 0);
          const n2 = Number(card.avaliacao?.n2 || 0);
          const n3 = Number(card.avaliacao?.n3 || 0);

          const notaParcial =
            peso > 0 ? ((peso * (n1 + n2 + n3)) / 3).toFixed(0) : "0";

          const start = card.date?.startdate;
          const due = card.date?.duedate;

          const membros = card.members?.map(m => m.name).filter(Boolean).join(", ");

          return {
            idCartao: card._id,
            tituloCartao: card.title,
            projetos: card.projetos,
            projetosDescricao: "",
            produto: card.produto,
            produtoDescricao: "",
            classificacao: "",
            atividade: cardGroup.title || "N/A",
            descricaoCartao: card.description || "N/A",
            complexidade: card.complexidade || "N/A",
            relevancia: card.relevancia || "N/A",
            ordemServico: card.ordemServico,
            quantidadeExecutada: card.quantidadeExecutada,
            quantidadeOS: card.quantidadeOS,
            numSeiAbertura: card.numSeiAbertura,
            numSeiEntrega: card.numSeiEntrega,
            criticidade,
            peso,
            numeroSEI: card.numSei || "N/A",
            n1,
            n2,
            n3,
            notaParcial,
            data:
              start && due ? `${start} - ${due}` : start || due || "N/A",
            dataPreEntrega: card.datePreEntrega || "N/A",
            dataEntrega: card.dateEntrega || "N/A",
            membros: membros || "N/A",
          };
        })
      );
    })
  );
};


  return (
    <>
      {(pending || isMonthLoading || isYearLoading || dashboardLoading) && (
        <LoadingScreen />
      )}
      <Container>
        <Navbar searchString={searchString} setSearchString={setSearchString} />
        <Wrapper>
          <Container>
            <Header>
              <h1>Detalhamento do Desempenho da Ação - {nomeCard}</h1>
              <FilterWrapper>
                {/* data mes/ano */}
                <select
                  value={selectedData.value}
                  onChange={(e) => {
                    handleMonthChange(e.target.value);
                  }}
                >
                  <option value="">Selecione a data</option>
                  {Array.isArray(selectedData) &&
                    selectedData.map((dt) => (
                      <option key={dt} value={dt}>
                        {dt}
                      </option>
                    ))}
                </select>
                {/* Quadro */}
                <select
                  value={selectedQuadro}
                  onChange={(e) => {
                    setSelectedQuadro(e.target.value);
                    BuscarDadosQuadro(e.target.value);
                  }}
                >
                  <option value="">Selecione um quadro</option>
                  {normalizedBoardsData.map((board) => (
                    <option key={board._id} value={board._id}>
                      {board.title}
                    </option>
                  ))}
                </select>
                {/* Produto */}
                <select
                  value={selectedProduto.value}
                  onChange={(e) => {
                    handleProdutoChange(e.target.value);
                  }}
                >
                  <option value="">Selecione um Produto</option>
                  {Array.isArray(selectedProduto) &&
                    selectedProduto.map((prod) => (
                      <option key={prod.value} value={prod.value}>
                        {prod.label}
                      </option>
                    ))}
                </select>
                <button onClick={exportToExcel}>Exportar para Excel</button>
              </FilterWrapper>
            </Header>

            <CardsWrapper>
              <Card color="#FFB74D">
                <h3>Soma Peso</h3>
                <p>{peso}</p>
              </Card>
              <Card color="#FFD54F">
                <h3>Soma Nota Parcial</h3>
                <p>{nota}</p>
              </Card>
              <Card color="#81C784">
                <h3>Nota Final de Ação</h3>
                <p>{notaFinal}</p>
              </Card>
              <Card color="#66BB6A">
                <h3>Desempenho</h3>
                <p>{desempenho}</p>
              </Card>
              <Card color="#66BB6A">
                <h3>Desconto</h3>
                <p>{desconto}</p>
              </Card>
            </CardsWrapper>

            <TableWrapper>
              <Table>
                <thead>
                  <tr>
                    <th>Projeto</th>
                    <th>Produto</th>
                    <th>Atividade</th>
                    <th>Demanda</th>
                    <th>Descrição</th>
                    <th>Criticidade</th>
                    <th>Peso</th>
                    <th>N1</th>
                    <th>N2</th>
                    <th>N3</th>
                    <th>NP</th>
                  </tr>
                </thead>
                <tbody>
                  {tableData.length === 0 ? (
                    <tr>
                      <td colSpan="10">Nenhum dado disponível.</td>
                    </tr>
                  ) : (
                    tableData.map((row) => (
                      <tr>
                        <td>{row.projetosDescricao}</td>
                        <td>{row.produtoDescricao}</td>
                        <td>{row.atividade}</td>
                        <td>{row.tituloCartao}</td>
                        <td>{row.descricaoCartao}</td>
                        <td>{row.criticidade}</td>
                        <td>{row.peso}</td>
                        <td>{row.n1}</td>
                        <td>{row.n2}</td>
                        <td>{row.n3}</td>
                        <td>{row.notaParcial}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>
            </TableWrapper>
          </Container>
        </Wrapper>
      </Container>
    </>
  );
};

export default Dashboard;
